var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"_whiteBackground mt-4 mr-0 ml-0 pa-0 pa-sm-10"},[_c('div',{staticClass:"_body"},[_c('div',{staticClass:"_title ml-4 mt-4"},[_vm._t("title")],2),_c('br'),_c('div',{staticClass:"_content mr-0 ml-0 mr-sm-10 ml-sm-10"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }